import types from './types';

const INITIAL_STATE = {
  isFetchingContracted: false,
  isFetchingAll: false,
  isFetchingAllDesc: false,
  isFetchingResources: false,
  isDeletingResources: false,
  isUploadingResources: false,
  isUpdatingResources: false,
  isUploadingProvResources: false,
  isFetchingProvider: false,
  isFetchingSpecialty: false,
  isDeletingDocument: false,
  isUpdatingDocument: false,

  result: [],
};

const appIPAReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_CONTRACTED_IPA_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingContracted: true,
      };

    case types.GET_CONTRACTED_IPA_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingContracted: false,
      };

    case types.GET_CONTRACTED_IPA_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingContracted: false,
      };

    case types.GET_ALL_IPAS_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAll: true,
      };

    case types.GET_ALL_IPAS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAll: false,
      };

    case types.GET_ALL_IPAS_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAll: false,
      };

    case types.GET_ALL_IPAS_DESC_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAllDesc: true,
      };

    case types.GET_ALL_IPAS_DESC_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAllDesc: false,
      };

    case types.GET_ALL_IPAS_DESC_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAllDesc: false,
      };

    case types.GET_IPA_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingResources: true,
      };

    case types.GET_IPA_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingResources: false,
      };

    case types.GET_IPA_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingResources: false,
      };

    case types.DELETE_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isDeletingResources: true,
      };

    case types.DELETE_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeletingResources: false,
      };

    case types.DELETE_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isDeletingResources: false,
      };
    case types.UPDATE_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isUpdatingResources: true,
      };

    case types.UPDATE_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdatingResources: false,
      };

    case types.UPDATE_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isUpdatingResources: false,
      };

    case types.UPLOAD_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isUploadingResources: true,
      };

    case types.UPLOAD_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUploadingResources: false,
      };

    case types.UPLOAD_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isUploadingResources: false,
      };

    case types.UPLOAD_PROVIDER_RESOURCES_REQUEST:
      return {
        ...state,
        result: [],
        isUploadingProvResources: true,
      };

    case types.UPLOAD_PROVIDER_RESOURCES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUploadingProvResources: false,
      };

    case types.UPLOAD_PROVIDER_RESOURCES_FAILURE:
      return {
        ...state,
        result: [],
        isUploadingProvResources: false,
      };
    case types.SEARCH_PROVIDER_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingProvider: true,
      };

    case types.SEARCH_PROVIDER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingProvider: false,
      };

    case types.SEARCH_PROVIDER_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingProvider: false,
      };

    case types.SEARCH_SPECIALTY_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingSpecialty: true,
      };

    case types.SEARCH_SPECIALTY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingSpecialty: false,
      };

    case types.SEARCH_SPECIALTY_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingSpecialty: false,
      };

    case types.UPDATE_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isUpdatingDocument: true,
      };

    case types.UPDATE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUpdatingDocument: false,
      };

    case types.UPDATE_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isUpdatingDocument: false,
      };

    case types.DELETE_DOCUMENTS_REQUEST:
      return {
        ...state,
        result: [],
        isDeletingDocument: true,
      };

    case types.DELETE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeletingDocument: false,
      };

    case types.DELETE_DOCUMENTS_FAILURE:
      return {
        ...state,
        result: [],
        isDeletingDocument: false,
      };

    default:
      return state;
  }
};

export default appIPAReducer;
